<template>
  <el-drawer
    :title="$t('Resource.waybillCompartmentQuery')"
    :visible.sync="searchDrawer"
    :wrapper-closable="false"
    center
    direction="ltr"
    size="900px"
  >
    <div style="padding: 0 20px; height: calc(100vh - 80px); overflow: auto">
      <el-form
        ref="searchFormRef"
        :inline="true"
        :model="searchForm.params"
        class="search-form"
        label-position="top"
        size="small"
      >
        <el-row :gutter="20">
          <el-col :span="10">
            <!--  运单号   -->
            <el-form-item
              :label="$t('Resource.anJunWaybillNumber')"
              :rules="{
                required: true,
                message: $t('GlobalSetObj.pleaseInput'),
                trigger: ['change']
              }"
              prop="inputValue"
              style="width: 100%"
            >
              <el-input
                v-model="searchForm.params.inputValue"
                :placeholder="$t('newOrder.PreciseSearch1')"
                :rows="1"
                style="width: 100%"
                type="textarea"
              />
            </el-form-item>
          </el-col>
          <el-col :span="7">
            <!--  设备名称 -->
            <el-form-item
              :label="$t('GlobalSetObj.TheNameOfTheDevice')"
              :rules="{
                required: true,
                message: $t('GlobalSetObj.pleaseChoose'),
                trigger: ['change']
              }"
              prop="deviceNumber"
              style="width: 100%"
            >
              <el-select
                v-model="searchForm.params.deviceNumber"
                :placeholder="$t('GlobalSetObj.pleaseChoose')"
                clearable
                filterable
                style="width: 100%"
              >
                <el-option
                  v-for="item in deviceList"
                  :key="item.id"
                  :label="item.deviceName"
                  :value="item.deviceNumber"
                />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="7">
            <div style="margin-top: 28px">
              <el-button
                size="small" type="primary" @click="enterSearch"
              >{{ $t('newOrder.search') }}
              </el-button>
              <el-button size="small" @click="resetForm">{{ $t('newOrder.reset') }}</el-button>
            </div>
          </el-col>
        </el-row>
      </el-form>
      <el-table
        :data="tableData"
        :header-cell-style="{ background: '#f2f2f2', color: 'black' }"
        border
        style="width: 100%"
      >
        <el-table-column
          :label="$t('GlobalSetObj.serial')"
          align="center"
          prop="index"
          type="index"
          width="60px"
        />
        <el-table-column
          :label="$t('Resource.anJunWaybillNumber')"
          align="center"
          min-width="160px"
          prop="waybillNumber"
        />
        <el-table-column
          :label="$t('Resource.belongingCompartment')"
          align="center"
          min-width="130px"
          prop="gridNumber"
        />
      </el-table>
      <div style="text-align: right">
        <el-pagination
          :current-page.sync="searchForm.pageNumber"
          :page-size.sync="searchForm.pageSize"
          :page-sizes="[10, 20, 50, 100]"
          :total="total"
          background
          layout="total, sizes, prev, pager, next, jumper"
          style="margin: 15px 0"
          @current-change="getSearch"
          @size-change="getSearch"
        />
      </div>
    </div>
  </el-drawer>
</template>

<script>
import { waybillCompartmentQuery } from '@/api/finance/basicData';
import { deviceManagementList } from '@/api/automaticSorting';

export default {
  data() {
    return {
      searchForm: {
        pageNumber: 1,
        pageSize: 10,
        params: {
          waybillNumberType: 0,
          deviceNumber: '',
          inputValue: ''
        }
      },
      tableData: [],
      total: 0,
      deviceList: [],
      searchDrawer: false
    };
  },
  methods: {
    showOrderNumber() {
      this.searchDrawer = true;
      this.$nextTick(() => {
        this.resetForm();
      });
      this.getEquipment();
      this.tableData = [];
    },
    enterSearch() {
      this.$refs['searchFormRef'].validate((valid) => {
        if (valid) {
          console.log(valid, 'enterSearch');
          this.getSearch();
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    getSearch() {
      const data = {
        pageNumber: this.searchForm.pageNumber,
        pageSize: this.searchForm.pageSize,
        params: {
          deviceNumber: this.searchForm.params.deviceNumber,
          waybillNumberList: []
        }
      };
      if (this.searchForm.params.inputValue) {
        data.params.waybillNumberList = this.searchForm.params.inputValue.split('\n');
        if (data.params.waybillNumberList.length > 2000) {
          this.$message.warning(this.$t('newOrder.searchMax1000'));
          data.params.waybillNumberList = data.params.waybillNumberList.slice(0, 2000); // 截取前2000个单号
        }
      }
      waybillCompartmentQuery(data).then((res) => {
        if (res.code === 200) {
          this.total = res.data.total;
          this.tableData = res.data.records;
        }
      });
    },
    getEquipment() {
      deviceManagementList().then((res) => {
        if (res.code === 200) {
          this.deviceList = res.data;
        }
      });
    },
    resetForm() {
      this.searchForm = {
        pageNumber: 1,
        pageSize: 10,
        params: {
          waybillNumberType: 0,
          deviceNumber: '',
          inputValue: ''
        }
      };
      // this.enterSearch();
      this.$refs['searchFormRef'].resetFields();
    }
  }
};
</script>

<style scoped>
.search-form {
  margin-bottom: 20px;
}

.selectLabel .el-input__inner {
  height: 28px !important;
  line-height: 28px !important;
  border: none;
  font-weight: bold;
  text-align: left;
  padding: 0 !important;
}

>>> .el-form-item {
  margin-bottom: 0 !important;
}
</style>
